import React, {useEffect, useState} from "react";
import {Box, Typography} from "@mui/material";
import MapAnomalyDetection from "./map.component";
import * as turf from "@turf/turf";

const parentHeight = 850;

function getReducedParentHeight(origHeight){
    var percent = 10.9; // percentage decrease
    var reducedHeight = origHeight / (1 + (percent / 100));
    return reducedHeight;
}

// function formatAnomalyList(verificationLogs){
//     var data = [];
//     if(verificationLogs.length != 0){
//         verificationLogs.map((element)=>{
            
//             console.log("element is here: ", element)
//             console.log(element.longitude && element.latitude ? "Has coordinates." : "Has something is missing.")

//             var jsonObject = {
//                 type: 'Feature',
//                 properties: {
//                     product: element.product_name,
//                     description:
//                     `<p><b>Product Code: </b>${element.product_code}</p>`
//                 },
//                 geometry: {
//                     type: 'Point',
//                     coordinates: [element.longitude, element.latitude]
//                 }
//             };
//             data.push(jsonObject);
//         })
//     }
//     const mapBoxCustomData = {
//         type: 'FeatureCollection',
//         features: data
//     }
//     return mapBoxCustomData;
// }

function formatAnomalyList(verificationLogs) {
    var data = [];
    const cityCounts = countAnomaliesPerCity(verificationLogs);
    
    if (verificationLogs.length !== 0) {
        verificationLogs.map((element) => {
            console.log("element is here: ", element);
            
            // Check if coordinates are available
            const hasCoordinates = element.latitude && element.longitude;
            console.log(hasCoordinates ? "Has coordinates." : "Coordinates are missing.");

            const city = element.city || "Unknown City"; // Default to "Unknown City" if city is missing
            const totalAnomalies = cityCounts[city] || 0;

            var jsonObject = {
                type: 'Feature',
                properties: {
                    verification_id: element.verification_id, // Add Verification ID
                    status: element.status, // Add Status
                    device_info: element.device_info, // Add Device Info
                    user_email: element.email, // Add User Email
                    product_name: element.business_name, // Add Business Name (or Product Name)
                    description: `
                        <p><b>Product Code: </b>${element.product_code}</p>
                        <p><b>Verification Type: </b>${element.verification_type}</p>
                        <p><b>Timestamp: </b>${element.timestamp}</p>
                        <p><b>Location: </b>${element.barangay}, ${element.municipality}, ${element.province}, ${element.region}</p>
                         <p><b>Total Anomalies: </b>${totalAnomalies}</p>
                    `
                },
                geometry: {
                    type: 'Point',
                    coordinates: hasCoordinates ? [element.longitude, element.latitude] : [0, 0] // Default to [0, 0] if no coordinates
                }
            };
            data.push(jsonObject);
        });
    }



    // Return the formatted data for map display
    const mapBoxCustomData = {
        type: 'FeatureCollection',
        features: data,
    };

    return mapBoxCustomData;
}


function countAnomaliesPerCity(verificationLogs) {
    const cityCount = {};

    // Loop through the verification logs
    verificationLogs.forEach((log) => {
        const city = log.city;

        if (!cityCount[city]) {
            cityCount[city] = 0;
        }

        cityCount[city]++;
    });

    return cityCount;
}

function getCityWithHighestAnomalies(verificationLogs) {
    const cityCount = {};

    // Count anomalies per city
    verificationLogs.forEach((log) => {
        const city = log.city;

        if (!cityCount[city]) {
            cityCount[city] = 0;
        }

        cityCount[city]++;
    });

    // Find the city with the highest anomalies
    let maxCity = null;
    let maxCount = 0;

    for (const [city, count] of Object.entries(cityCount)) {
        if (count > maxCount) {
            maxCity = city;
            maxCount = count;
        }
    }

    return { city: maxCity, count: maxCount };
}


const getCenterCamera = (formatted_anomaly) => {
    var transformedCoordinates = []; 
    formatted_anomaly.features.forEach((element)=>{
        var coords = [];
        coords.push(element.geometry.coordinates[0]);
        coords.push(element.geometry.coordinates[1]);
        transformedCoordinates.push(coords);
    })
    let centerCamera;
    const polygon = {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [
                transformedCoordinates
            ]
        }
    };
    // For center focus camera map
    if (transformedCoordinates.length == 1) {
        polygon.geometry.coordinates = transformedCoordinates[0];
        centerCamera = polygon;
    } else {
        centerCamera = turf.centroid(polygon);
    }
    return centerCamera
}

const AnomalyLocationsComponent = (props) => {

    const {breakpoints, verificationLogs, selectedAnomaly} = props;
    const [formatted_anomaly, setFormattedAnomaly] = useState();
    const [anomalies_per_city, setAnomaliesPerCity] = useState();
    const [highest_anomaly, setHighestAnomaly] = useState();
    const [center_camera_coordinates, setCenterCameraCoordinates] = useState();


    useEffect(() => {
        if (!verificationLogs || verificationLogs.length === 0) return;
    
        const formattedAnomaly = formatAnomalyList(verificationLogs);
        const anomaliesPerCity = countAnomaliesPerCity(verificationLogs);
        const highestAnomaly  = getCityWithHighestAnomalies(verificationLogs);

        setFormattedAnomaly(formattedAnomaly);
        setAnomaliesPerCity(anomaliesPerCity);
        setHighestAnomaly(highestAnomaly);
        setCenterCameraCoordinates([121.75, 12.0]); 
    }, [JSON.stringify(verificationLogs)]);



    useEffect(()=>{
        if(selectedAnomaly == null) return;
        var formattedAnomaly = formatAnomalyList(selectedAnomaly);
        setFormattedAnomaly(formattedAnomaly);
        setCenterCameraCoordinates(getCenterCamera(formattedAnomaly).geometry.coordinates);
    }, [selectedAnomaly])

    return (
        <Box sx={{ml: 3, padding: 3, borderRadius: "6px",
            backgroundColor: "#fff", height: parentHeight, pt: "16px"
        }}>
            <Typography sx={{color: "#58565f", fontSize: 18}}>
                Anomaly Locations
            </Typography>
            <MapAnomalyDetection formatted_anomaly={formatted_anomaly} highest_anomaly={highest_anomaly} center_camera_coordinates={center_camera_coordinates} parentHeight={getReducedParentHeight(parentHeight)} />
        </Box>
    )
}

export default AnomalyLocationsComponent